<div class="header" fxLayout="row">
    <h1 class="mat-dialog-title">Note</h1>
    <button mat-icon-button type="button" class="close-dialog" color="basic" mat-dialog-close aria-label="Luk note dialog" tabindex="0">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<mat-dialog-content>
    @if (error.title) {
        <div class="alert alert-danger">
            <h3>{{ error.title }}</h3>
            @if (error.details) {
                <div>{{ error.details }}</div>
            }
        </div>
    }
    <note #notePanel [formGroup]="formGroup"></note>
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (options.slet && formGroup.value.noteId !== 0) {
        <button mat-button type="button" color="warn" (click)="onSlet()" aria-label="Slet note" role="button" type="button">SLET</button>
    }
    @if (options.gem) {
        <button mat-flat-button type="button" color="primary" (click)="onGem()" aria-label="Gem note" role="button" type="button">GEM</button>
    }
</mat-dialog-actions>
